import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISiteNamedUserModel } from '@apps-common/types/portal/users'

export const QUERY_GET_UNIT_SITE_USER = (userId?: number, unitId?: string) => ['getUnitNamedUser', userId, unitId].filter(Boolean)

const getUnitNamedUser = async (userId?: number, unitId?: string): Promise<ISiteNamedUserModel> =>
  axios.get(`/unit/GetUnitNamedUser?userId=${userId}&unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitNamedUser

type Props = {
  config?: QueryConfig<QueryFnType>
  userId?: number
  unitId?: string
}

export const useGetUnitNamedUser = ({ config, userId, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_SITE_USER(userId, unitId),
    queryFn: () => getUnitNamedUser(userId, unitId)
  })
